import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getLandingPageSettings, getLandingPageSubdomain, getHandle, getCompanyLogoUrl, getOnboardingPlaybookId } from 'modules/playbook/selectors'
import { getCompanyName } from 'modules/playbook/selectors';
import { getEmbedId } from 'modules/org/selectors'
import { updateCLPSettings, fetchCLPSettings, fetchCLPCname, fetchCLPSubdomain, setCLPSubdomain } from 'modules/playbook/actions'
import CLPCustomizeStep from 'layouts/OnboardingCLPCustomizeStep'

const mapStateToProps = state => ({
  logoUrl: getCompanyLogoUrl(state),
  companyName: getCompanyName(state),
  embedId: getEmbedId(state),
  landingPageSettings: getLandingPageSettings(state),
  landingPageSubdomain: getLandingPageSubdomain(state),
  playbookId: getOnboardingPlaybookId(state),
  handle: getHandle(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateCLPSettings,
    fetchCLPCname,
    fetchCLPSettings,
    fetchCLPSubdomain,
    setCLPSubdomain
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CLPCustomizeStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/CLPCustomizeStep/index.js